
import {
  apiDesignTask,
  apiDesignTaskDelete,
  apiDesignTaskReset,
  apiDesignTaskSkuListImages,
} from "@/api/app";

import { Component, Prop, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import { RequestPaging } from "@/utils/util";
import { apiShopLists } from "@/api/shop";
import DatePicker from "@/components/date-picker.vue";
import { apiDesignDetail } from "@/api/app";

@Component({
  components: {
    lsPagination,
    DatePicker,
  },
})
export default class DesignTaskList extends Vue {
  $refs!: { datePickerRef: any };
  /** S Data **/
  searchObj: any = {
    id: "",
    shop_sn: "",
    target_type: 4,
    // 获取今日日期
    create_time_start: "",
    // 获取明日日期
    create_time_end: "",
    page_no: 1,
    page_size: 150,
    status: -10,
    version: "real",
    out_id: "",
    sn: "",
    code: "",
  };
  time: any = [];
  lists: any = [];
  total = 0;
  selectIds: any = [];
  shopList: any = [];
  shops = {};
  targetTypeList: any = [
    {
      label: "全部",
      value: "",
    },
    {
      label: "商户后台设计",
      value: 1,
    },
    {
      label: "用户设计",
      value: 2,
    },
    {
      label: "用户设计合成",
      value: 3,
    },
    {
      label: "生产图",
      value: 4,
    },
    {
      label: "规格图片",
      value: 5,
    },
    {
      label: "无需设计生产图",
      value: 6,
    },
  ];
  statusList: any = [
    { label: "全部", value: -10 },
    { label: "待制作", value: 0 },
    { label: "制作中", value: 1 },
    { label: "制作完成", value: 2 },
  ];

  pickerOptions = {
    shortcuts: [
      {
        text: "最近一周",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近一个月",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近三个月",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        },
      },
    ],
  };

  designData: any = {};

  dialogVisible: boolean = false;

  images: any = [];

  specEffectVisbile: boolean = false;

  effectList: any = [];

  loading = false;

  isDesign = false;

  /** E Data **/
  apiDesignTask = apiDesignTask;

  pager: RequestPaging = new RequestPaging({ size: 50 });

  handleChangeTargetTypeByOrder(value: string, target_type: number) {
    this.searchObj.sn = value;
    this.searchObj.target_type = target_type;
    this.searchObj.page_no = 1;
    this.getList();
  }

  getList() {
    this.loading = true;
    apiDesignTask(this.searchObj).then((res) => {
      this.lists = res.lists;
      this.total = res.count;
      this.loading = false;
    });
  }
  changeDate() {
    if (!this.time) {
      this.searchObj.create_time_start = "";
      this.searchObj.create_time_end = "";
    } else {
      this.searchObj.create_time_start = this.time[0];
      this.searchObj.create_time_end = this.time[1];
    }
    this.searchObj.page_no = 1;
    this.getList();
  }
  goModelList(code: string) {
    window.open(`/platform/model/model_list?code=${code}`, "_blank");
  }
  getStusLabel(status: number) {
    const item = this.statusList.find((item: any) => item.value == status);
    return item ? item.label : "";
  }

  handleSelectionChange(val: any) {
    this.selectIds = val.map((item: any) => item.id);
  }
  handleCreate(row: any) {
    window.open(
      `/platform/design/${
        row.target_type == 4 || row.target_type == 6 ? "factory" : "effect"
      }?id=${row.id}&auto=0`,
      "_blank",
    );
  }
  handlePreview(row: any) {
    window.open(`/platform/design/preview?id=${row.id}`, "_blank");
  }

  handleViewImage(row: any) {
    this.images = this.getImages(row);
    this.dialogVisible = true;
  }
  handleReset(id: any) {
    const ids = id ? [id] : this.selectIds;
    this.$confirm("是否确定重置?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      apiDesignTaskReset({ ids }).then(() => {
        this.resetSearch();
      });
    });
  }
  handleDelete(id: any) {
    const ids = id ? [id] : this.selectIds;
    this.$confirm("是否确定删除?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      apiDesignTaskDelete({ ids }).then(() => {
        this.resetSearch();
      });
    });
  }
  getImages(row: any) {
    const images =
      row.images.length > 0 && row.images[0] != "" ? row.images : [row.image];
    return images ? images.filter((item: any) => item !== "") : [];
  }
  resetSearch() {
    this.searchObj = {
      id: "",
      shop_sn: "",
      target_type: 2,
      // 获取今日日期
      create_time_start: "",
      // 获取明日日期
      create_time_end: "",
      page_no: 1,
      page_size: 200,
      status: -10,
      version: "",
    };
    this.searchObj.page_no = 1;
    this.getList();
  }
  getShopList() {
    apiShopLists({
      page: 1,
      page_size: 10000,
    }).then((res) => {
      this.shopList = res.lists;
      let list: any = {};
      for (let item of res.lists) {
        list[item.sn] = item.name;
      }
      this.shops = list;
    });
  }
  currentChange(val: any) {
    this.searchObj.page_no = val;
    this.getList();
  }
  handleSpec(row: any) {
    apiDesignTaskSkuListImages({
      id: row.id,
    }).then((res) => {
      this.effectList = res;
      this.specEffectVisbile = true;
    });
  }
  async handleDetail(row: any) {
    try {
      // 获取设计详情
      const res = await apiDesignDetail({ id: row.id });
      console.log("🚀 ~ DesignTaskList ~ handleDetail ~ res:", res);
      if (!res.design) {
        return;
      }
      this.designData = res.design;

      // 获取设计 URL 数据
      const response = await fetch(this.designData.design_url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();

      // 提取自定义图片和设计 JSON 数据
      const origin_images: string[] = [];
      const font_data: any = [];
      this.isDesign = false;
      for (const designItem of data.design) {
        for (const objectItem of designItem.objects) {
          if (objectItem.name === "customize") {
            this.isDesign = true;
            if (objectItem.type == "image") {
              origin_images.push(objectItem.src);
            } else if (objectItem.type == "text") {
              font_data.push({
                content: objectItem.text,
                fontFamily: objectItem.fontFamily,
              });
            }
          }
        }
      }
      // 对 origin_images 去重
      const uniqueOriginImages = [...new Set(origin_images)];
      const jsonData = JSON.stringify(data.design);
      // 更新设计数据并显示对话框
      this.designData = {
        design_json: jsonData,
        origin_images: uniqueOriginImages,
        font_data: font_data,
      };
      this.dialogVisible = true;
    } catch (error) {
      console.error("获取设计详情失败:", error);
      this.$message.error("获取设计详情失败，请稍后重试");
    }
  }
  /** E Methods **/

  /** S ods **/
  created() {
    this.searchObj.create_time_start = new Date().toISOString().split("T")[0];
    this.searchObj.create_time_end = new Date().toISOString().split("T")[0];
    this.time = [
      this.searchObj.create_time_start,
      this.searchObj.create_time_end,
    ];
    this.getList();
    this.getShopList();
  }
}
